module.exports = function getResource(label) {
    let resources = {
        endingIn: 'se terminant par',
        cardNumber: 'Numéro de carte',
        mm: 'MM',
        yy: 'AA',
        cvc: 'CVV/CVC',
        moreInfoPopover: 'Plus d’informations relatives au CVC',
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        billingAddress: 'Adresse de facturation',
        useMyAddressRadio: 'Utiliser mon adresse de livraison',
        useDiffAddressRadio: 'Utiliser une adresse différente',
        saveCardCheckboxText: 'Sauvegarder cette carte pour des achats futurs',
        makeDefaultCheckboxText: 'Définir comme carte par défaut',
        editCardTitle: 'Modifiez la carte de crédit ou de débit',
        addNewCardTitle: 'Ajoutez une nouvelle carte de crédit ou de débit',
        cancelButton: 'Annuler',
        saveContinueButton: 'Enregistrer et continuer',
        borderFreeCCWarning: 'Veuillez entrer de nouveau les renseignements de votre carte de crédit',
        debitCardDisclaimer: 'Cartes de débit Visa et MasterCard seulement'
    };

    return resources[label];
};
